import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../context/AlertContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./Menu";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";


export default function Movimientos(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const isPortrait = window.matchMedia("(orientation: portrait)").matches;
  let navigate = useNavigate();

  const exportColumns = [
    { title: "Fecha", dataKey: "fecha" },
    { title: "Artículo", dataKey: "descripcion" },
    { title: "Movimiento", dataKey: "tipoMovimiento" },
    { title: "Cantidad", dataKey: "cantidad" },
    { title: "Detalle", dataKey: "detalle" },
  ];


  const tiposMovimientos = [
    { key: 1, value: "ENTRADA" },
    { key: 2, value: "SALIDA" },
  ];


  const [movimiento, guardarMovimiento] = useState(null);
  const [visible, setVisible] = useState(false);
  const [tipoMovimiento, setTipoMovimiento] = useState("");
  const toast = useRef(null);

  const handleChange = (event) => {
    setTipoMovimiento(event.target.value);
  };

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    statusAcceso,
    statusAcceso2,
    articulos,
    movimientos,
    obtenerMovimientos,
    obtenerAcceso,
    obtenerAcceso2,
    actualizarMovimiento,
    agregarMovimiento,
    obtenerArticulos,
  } = serviciosContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Movimientos" });
    }
  }, [state]);

  useEffect(() => {
    obtenerMovimientos();
    obtenerArticulos({ todos: false });
  }, []);

  const editClick = (e) => {
    if (selectedRow) {
      guardarMovimiento(selectedRow);
      setVisible(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un artículo.",
        life: 3000,
      });
    }
  };

  const addClick = (e) => {
    //props.history.push(`/movimiento/0`);
    setVisible(true);
    setSelectedRow(null);
    guardarMovimiento({
      habilitado: true,
    });
  };

  const exitClick = (e) => {
    navigate("/");
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const aceptarClick = (e) => {
    e.preventDefault();
    //Validar
    if (
      !movimiento ||
      movimiento.articuloId === undefined ||
      movimiento.articuloId === null ||
      movimiento.articuloId === "" ||
      movimiento.articuloId === 0
    ) {
      mensajeAlerta("Movimientos", "El artículo es necesario !.", "error");
      return;
    }

    if (
      !movimiento ||
      movimiento.cantidad === undefined ||
      movimiento.cantidad === null ||
      movimiento.cantidad === "" ||
      movimiento.cantidad === 0
    ) {
      mensajeAlerta("Movimientos", "La cantidad es necesaria !.", "error");
      return;
    }

    if (
      !movimiento ||
      movimiento.tipoMovimiento === undefined ||
      movimiento.tipoMovimiento === null ||
      movimiento.tipoMovimiento === "" 
    ) {
      mensajeAlerta("Movimientos", "El tipo de movimiento es necesario !.", "error");
      return;
    }


    // Llamar al context
    if (selectedRow) {
      //actualizarMovimiento({ movimiento });
    } else {
      agregarMovimiento({ movimiento });
    }
    onHide();
    setSelectedRow(null);
    setTimeout(() => {
      obtenerMovimientos();
    }, 2000);
    //exitClick();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Movimientos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const idTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">ID</span>
        {rowData.id}
      </Fragment>
    );
  };

  const descripcionTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Descripción</span>
        {rowData.descripcion}
      </Fragment>
    );
  };

  const stockTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Stock</span>
        {rowData.stock}
      </Fragment>
    );
  };

  const unidadTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Unid. de medida</span>
        {rowData.unidad}
      </Fragment>
    );
  };

  const habilitadoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.habilitado}></Checkbox>
      </Fragment>
    );
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, movimientos);
        doc.save("movimientos.pdf");
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(movimientos);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "movimientos");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
        resolve(true);
      });
    });
  };

  const header = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <Button
          type="button"
          icon="pi pi-file-excel"
          onClick={exportExcel}
          className="p-button-success p-mr-2"
          data-pr-tooltip="XLS"
        />
        <Button
          type="button"
          icon="pi pi-file-pdf"
          onClick={exportPdf}
          className="p-button-warning p-mr-2"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
        />
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag value="Movimientos"></Tag>
      </div>
    </Fragment>
  );

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Movimiento"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(movimientosNaturales);
  //console.log(state);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          {movimientos ? (
            <Fragment>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
               style={{
                  align: "center",
                  margin: "1em",
                  marginTop:
                    isMobile && !isPortrait
                      ? "22vw"
                      : isMobile && isPortrait
                      ? "55vw"
                      : "0vw",
                }}
              >
                <Button
                  icon="pi pi-plus"
                  tooltip="Agregar"
                  className="p-button-rounded p-button-help"
                  style={{ marginLeft: "0em" }}
                  onClick={addClick}
                />
                <Button
                  icon="pi pi-times"
                  tooltip="Cerrar"
                  className="p-button-rounded p-button-primary"
                  style={{ marginLeft: "1em" }}
                  onClick={exitClick}
                />
                <div className="datatable-responsive-demo">
                  <div className="card">
                    <Tooltip
                      target=".export-buttons>button"
                      position="bottom"
                    />
                    <DataTable
                      value={movimientos}
                      selection={selectedRow}
                      onSelectionChange={(e) => setSelectedRow(e.value)}
                      selectionMode="single"
                      dataKey="id"
                      header={header}
                      className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                      style={{ fontSize: "small", marginTop: "1vw" }}
                      globalFilter={globalFilter}
                      emptyMessage="No hay datos."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={10}
                      rowsPerPageOptions={[10, 20, 50]}
                      //paginatorLeft={paginatorLeft}
                      //paginatorRight={paginatorRight}
                    >
                      <Column
                        field="id"
                        header="ID"
                        //body={idTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="fecha"
                        header="Fecha"
                        //body={descripcionTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="descripcion"
                        header="Artículo"
                        //body={stockTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="tipoMovimiento"
                        header="Movimiento"
                        //body={unidadTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="cantidad"
                        header="Cantidad"
                        //body={unidadTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="detalle"
                        header="Detalle"
                        sortable
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </Grid>
              <Dialog
                header={renderHeader()}
                visible={visible}
                closable={false}
                footer={renderFooter()}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "50vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                  {selectedRow ? (
                    <Grid item xs={12} md={2}>
                      <TextField
                        value={movimiento ? movimiento.id : null}
                        required
                        variant="standard"
                        id="id"
                        label="ID"
                        fullWidth
                        disabled
                      />
                    </Grid>
                  ) : null}
                  <Grid item xs={12} md={12}>
                    <Autocomplete
                      id="articulo"
                      fullWidth
                      options={articulos}
                      disablePortal
                      getOptionLabel={(option) => option.descripcion}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          style={{ marginTop: "0vw" }}
                          label="Artículos"
                        />
                      )}
                      //onKeyDown={handleEnter}
                      onChange={(event, value) => {
                        if (value) {
                          guardarMovimiento({
                            ...movimiento,
                            articuloId: value.id,
                            articuloDescripcion: value.label,
                          });
                        } else {
                          guardarMovimiento({
                            ...movimiento,
                            articuloId: null,
                            articuloDescripcion: null,
                          });
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} md={6}>
                    <TextField
                      value={movimiento ? movimiento.cantidad : null}
                      required
                      variant="standard"
                      type="number"
                      id="cantidad"
                      label="Cantidad"
                      fullWidth
                      onChange={(e) => {
                        guardarMovimiento({
                          ...movimiento,
                          cantidad: e.target.value,
                        });
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} md={6}>
                  <Autocomplete
                      id="tipoMovimiento"
                      fullWidth
                      options={tiposMovimientos}
                      disablePortal
                      getOptionLabel={(option) => option.value}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          style={{ marginTop: "0vw" }}
                          label="Tipo de Movimiento"
                        />
                      )}
                      //onKeyDown={handleEnter}
                      onChange={(event, value) => {
                        if (value) {
                          guardarMovimiento({
                            ...movimiento,
                            tipoMovimiento: value.value,
                          });
                        } else {
                          guardarMovimiento({
                            ...movimiento,
                            tipoMovimiento: null,
                          });
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      value={movimiento ? movimiento.detalle : null}
                      variant="standard"
                      id="detalle"
                      label="Detalle"
                      fullWidth
                      onChange={(e) =>
                        guardarMovimiento({
                          ...movimiento,
                          detalle: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </Dialog>
            </Fragment>
          ) : (
            <Spinner />
          )}
          <Grid item xs={12} sm={12}></Grid>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
